/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:21:59
 * @Description:
 */

export const priceNum = (Vue) => {
	// 这里注册你的指令
};
